import React from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import InsightsBestDeals from './InsightsBestDeals';
import { getBestDealsMarket } from './BestDealsMarkets';

export default function BestDealsMarketPage() {
  const { marketSlug } = useParams();
  const market = getBestDealsMarket(marketSlug);

  if (!market) {
    return (
      <main className="min-h-[50vh] bg-slate-50 px-4 py-16 text-center">
        <Helmet>
          <title>Market Not Found | Meshum</title>
          <meta name="robots" content="noindex,follow" />
        </Helmet>
        <h1 className="text-3xl font-semibold text-slate-950">Market not found</h1>
        <p className="mt-3 text-slate-600">This local Best Deals market is not available.</p>
      </main>
    );
  }

  return <InsightsBestDeals market={market} />;
}
